import { createFileRoute, Outlet } from '@tanstack/react-router'
import { requireModule, requirePermission } from '../../../app/guards'

export const Route = createFileRoute('/_app/teams')({
  staticData: { crumb: 'teams' },
  beforeLoad: ({ context }) => {
    requireModule(context.session, 'tasks')
    requirePermission(context.session, 'tasks.read')
  },
  component: Outlet,
})
